import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { PaymentMethodSelector } from './components';
import { usePaymentSelectedModal } from './hooks/usePaymentSelectedModal';
import { usePaymentTitle } from './hooks/usePaymentTitle';

import { Loader, Modal, NavBar } from '@/components';
import useHostbackButton from '@/hooks/useHostbackButton';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import usePinsAccount from '@/hooks/usePinsAccount';
import ROUTES from '@/router/routes';
import { cn, lockScroll, PAYMENT_METHODS } from '@/utils';

export const PaymentMethods = () => {
  const navigate = useNavigate();
  const { isMobile, isDesktop } = useIsDesktop();
  const [isLoaded, setIsLoaded] = useState(false);
  const { methodPayment } = usePaymentSelectedModal();
  const { pinsData, handleSetPinsData } = usePinsAccount();
  const title = usePaymentTitle();

  useEffect(() => {
    handleSetPinsData({
      ...pinsData,
      selectedPaymentMethod: undefined,
      showModalPayInInstallments: false,
      selectedInstallment: undefined,
      showWalletLoadModal: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isLoaded) {
      setIsLoaded(true);
    }
  }, [isLoaded]);

  useEffect(() => {
    lockScroll(false);
    return () => {
      lockScroll(false);
    };
  }, []);

  const handleCleanState = () => {
    if (pinsData.moneyToWallet) {
      handleSetPinsData({
        ...pinsData,
        showPaymentModalMethod: false,
        showWalletLoadModal: true,
      });
    } else {
      handleSetPinsData({
        ...pinsData,
        selectedProduct: undefined,
        showPaymentModalMethod: false,
      });
    }
  };
  const handleBackButton = useCallback(() => {
    if (pinsData.selectedPaymentMethod !== undefined) {
      return handleSetPinsData({
        ...pinsData,
        selectedPaymentMethod: undefined,
      });
    }
    navigate(ROUTES.myAccount, {
      replace: true,
    });
  }, [handleSetPinsData, navigate, pinsData]);
  useHostbackButton(handleBackButton);

  const isCardMethod = useMemo(() => {
    return PAYMENT_METHODS.DEB_CRED === pinsData.selectedPaymentMethod;
  }, [pinsData.selectedPaymentMethod]);

  if (isMobile && !isDesktop) {
    return (
      <>
        <Loader isVisible={!isLoaded} />
        <NavBar
          desktop
          mobile={{
            leftContent: {
              backAction: () => {
                navigate(ROUTES.myAccount, {
                  replace: true,
                });
              },
            },
            centerContent: {
              title,
            },
          }}
        >
          <>
            <PaymentMethodSelector
              amountToWallet={pinsData.moneyToWallet}
              product={pinsData.selectedProduct}
            />
            <Modal
              controlledOnClose={() =>
                handleSetPinsData({
                  ...pinsData,
                  selectedPaymentMethod: undefined,
                  showWalletLoadModal: false,
                })
              }
              isControlledOpen={Boolean(methodPayment?.isOpen) && !isCardMethod}
              render={() => methodPayment?.component}
              size="xs"
              variant="controlled"
            />
          </>
        </NavBar>
      </>
    );
  }

  if (isDesktop && !isMobile) {
    <Loader isVisible={!isLoaded && isDesktop} />;
    return (
      <>
        <Modal
          className={cn('hidden lg:px-7', {
            'inline-block': isLoaded,
          })}
          controlledOnClose={() => handleCleanState()}
          isControlledOpen={Boolean(pinsData.showPaymentModalMethod)}
          render={() => (
            <PaymentMethodSelector
              amountToWallet={pinsData.moneyToWallet}
              product={pinsData.selectedProduct}
            />
          )}
          size="xs"
          title={title}
          variant="controlled"
        />
        <Modal
          controlledOnClose={() =>
            handleSetPinsData({
              ...pinsData,
              selectedPaymentMethod: undefined,
              showWalletLoadModal: false,
            })
          }
          isControlledOpen={Boolean(methodPayment?.isOpen)}
          render={() => methodPayment?.component}
          size="xs"
          title={isCardMethod && title}
          variant="controlled"
          withBack={Boolean(
            PAYMENT_METHODS.DEB_CRED === pinsData.selectedPaymentMethod
          )}
        />
      </>
    );
  }
};
